import React, { useLayoutEffect, useEffect, useRef, useState } from "react"
import "../components/page-teasers.scss"
import LocomotiveScroll from 'locomotive-scroll'
import TransitionLink from 'gatsby-plugin-transition-link'
import useWindowDimensions from '../hooks/useWindowDimensions'
import { StaticImage } from "gatsby-plugin-image"
import { gsap } from "gsap"
import { Link } from "gatsby";


import ringsgy from "../images/RINGS_GREEEN_YELLOW.svg"
import ringsmy from "../images/RINGS_MAGENTA_YELLOW.svg"
import ringscy from "../images/RINGS_CYAN_YELLOW.svg"
import ringsbm from "../images/RINGS_BLUE_MAGENTA.svg"
import ringsby from "../images/RINGS_BLUE_YELLOW.svg"


import imgA from "../images/Hero_01_Welcome.jpg"
import imgB from "../images/Hero_02a_BoardLetter.jpg"
import imgB3 from "../images/Hero_02b_CEOLetter_REV.jpg"
import imgC from "../images/Hero_04_Operations_REV.jpg"
import imgD from "../images/Hero_09_Markets.jpg"
import imgB2 from "../images/Hero_Officers.jpg"
import imgE from "../images/Hero_05_Reliability_Resilience.jpg"
import imgF from "../images/Hero_07_Planning.jpg"
import imgG from "../images/Hero_06_RiskManagement.jpg"
import imgH from "../images/Hero_08_Innovation.jpg"
import imgI from "../images/Hero_10_Culture.jpg"

export default function PageTeasers(props) {
    const scrollContainer = useRef();
    const teasers = useRef([]);
    const titleSupers = useRef([]);
    const titles = useRef([]);
    const circles = useRef([]);
    const { height } = useWindowDimensions();
    const [scroll, setScroll] = useState();
    const navList = useRef();
    const [activeItem, setActiveItem] = useState(0);

    useLayoutEffect(() => {
        setScroll(new LocomotiveScroll({
            el: scrollContainer.current,
            smooth: true,
            direction: 'horizontal',
            lerp: .1,
            reloadOnContextChange: true,
            // touchMultiplier: 2,
            smoothMobile: 0,
            smartphone: {
                smooth: !0,
                breakpoint: 767,
                direction: "horizontal",
                lerp: 0,
                gestureDirection: "vertical",
            },
            tablet: {
                smooth: true,
                breakpoint: 1024,
                direction: "horizontal",
                lerp: 0,
                gestureDirection: "vertical",
            },
        }));

        gsap.from(navList.current, {
            y: "-100%",
            duration: .35,
            ease: "power2"
        });

    }, []);

    useEffect(() => {
        console.log(props);

        scrollContainer.current.addEventListener('scroll', function(event) {
            // console.log('scrolled', event.target.scrollLeft);
            if(event.target.scrollLeft !== 0) {
                event.target.scrollLeft = 0;
            }
        });
    }, []);

    useEffect(() => {
        console.log('props', props.indexProps);
        if(props.indexProps.location.state !== null && props.indexProps.location.state.pageId !== undefined && scroll !== undefined) {
            scroll.scrollTo(teasers.current[parseInt(props.indexProps.location.state.pageId)], {
                duration: 0
            })
        }

        if(scroll !== undefined) {
            // console.log('fired');
            scroll.on('scroll', (args) => {
                // Get all current elements : args.currentElements
                for(let x = 0; x < 10; x++) {
                    if(typeof args.currentElements[x.toString()] === 'object') {
                        let progress = args.currentElements[x.toString()].progress;
                        // console.log('prog' + x, progress);

                        if(progress > .5) {
                            updateScrollColor(x);
                        }
                    }    
                }
            });
        }

        let color = 0;
        function updateScrollColor(int) {
            console.log(int);
            if(int !== color) {
                console.log('update color', int);
                color = int;
                setActiveItem(int);
            }
        }
    }, [scroll]);

    function exitAnimation(exit, node, int, arr) {
        scroll.scrollTo(teasers.current[int], {
            duration: 400,
            disableLerp: true,
            callback: function() {
                titleSupers.current[int].style.transform = "none";
                titles.current[int].style.transform = "none";
                for(let x = 0; x < arr.length; x++) {
                    circles.current[arr[x]].style.transform = "none";    
                }                
                scroll.destroy();
            }
        });

        gsap.to(navList.current, {
            y: "-100%",
            duration: .35,
            ease: "power2"
        });
    }

    function handleClick(int) {
        scroll.scrollTo(teasers.current[int], {
            duration: 800,
        });
        scroll.scrollTo(teasers.current[int], {
            duration: 800,
        });
    }

    function scrollCall() {
        console.log('call');
    }

    return (
        <>
        <div className="row nav-page-teasers">
            <div className="col-xs-12">
                <nav>
                    <ul ref={navList}>
                        <li onClick={() => {handleClick(0)}} data-url="welcome"><button style={activeItem === 0 ? {'color': '#F4C22A'} : null}>Welcome</button></li>
                        <li onClick={() => {handleClick(1)}} data-url="board-ceo-letters"><button style={activeItem === 1 ? {'color': '#F4C22A'} : null}>Board & CEO Letters</button></li>
                        <li onClick={() => {handleClick(2)}} data-url="officers"><button style={activeItem === 2 ? {'color': '#F4C22A'} : null}>Officers</button></li>
                        <li onClick={() => {handleClick(3)}} data-url="operations"><button style={activeItem === 3 ? {'color': '#F4C22A'} : null}>OPERATIONS</button></li>
                        <li onClick={() => {handleClick(4)}} data-url="markets"><button style={activeItem === 4 ? {'color': '#F4C22A'} : null}>Markets</button></li>
                        <li onClick={() => {handleClick(5)}} data-url="reliability-resilience"><button style={activeItem === 5 ? {'color': '#F4C22A'} : null}>Reliability & Resilience</button></li>
                        <li onClick={() => {handleClick(6)}} data-url="planning"><button style={activeItem === 6 ? {'color': '#F4C22A'} : null}>PLANNING</button></li>
                        <li onClick={() => {handleClick(7)}} data-url="risk-management"><button style={activeItem === 7 ? {'color': '#F4C22A'} : null}>RISK MANAGEMENT</button></li>
                        <li onClick={() => {handleClick(8)}} data-url="innovation"><button style={activeItem === 8 ? {'color': '#F4C22A'} : null}>INNOVATION</button></li>
                        <li onClick={() => {handleClick(9)}} data-url="culture-of-caring"><button style={activeItem === 9 ? {'color': '#F4C22A'} : null}>CULTURE OF CARING</button></li>
                    </ul>
                </nav>
            </div>
        </div>
        <div className="page-teasers" style={{height: height + "px"}}>
            <div className="teasers" ref={scrollContainer}>
                <div className="teaser" ref={(element) => teasers.current[0] = element}>
                    <div className="wrap">
                        <div className="profile" data-scroll-call="scrollCall" data-scroll-id="0" data-scroll data-scroll-speed="0">
                            <img objectFit="contain" className="avatar" src={imgA} alt="" />
                            <img className="rings" src={ringsgy} alt="" /> 
                        </div>
                        <div className="info welcome-teaser">
                            <div ref={(element) => titleSupers.current[0] = element} data-scroll data-scroll-speed="3" className="title--super text--outline">ON COMMON</div>
                            <h1 ref={(element) => titles.current[0] = element} data-scroll data-scroll-speed="2">GROUND</h1>
                            <div className="button-wrap">
                                <TransitionLink
                                    className="button"
                                    to="/welcome"
                                    exit={{
                                        trigger: ({ exit, node }) => exitAnimation(exit, node, 0, [0,1]),
                                        length: .6,
                                    }}
                                    entry={{
                                        delay: .6,
                                    }}
                                >
                                    Read Welcome
                                </TransitionLink>
                            </div>
                        </div>
                    </div>
                    <div 
                        ref={(element) => circles.current[0] = element}
                        className="circle--pink p-1"
                        data-scroll
                        data-scroll-speed="-2"
                        data-scroll-direction="horizontal"
                    ></div>
                    <div
                        ref={(element) => circles.current[1] = element}
                        className="circle--blue p-1" 
                        data-scroll
                        data-scroll-speed="-4" 
                        data-scroll-direction="vertical"
                    ></div>
                </div>
                <div className="teaser" ref={(element) => teasers.current[1] = element}>
                    <div className="wrap">
                        <div className="profile" data-scroll-call="scrollCall" data-scroll-id="1" data-scroll data-scroll-speed="0">
                            <div className="profile-1">
								<img objectFit="contain" className="avatar" src={imgB} alt="" />
                                <img className="rings" src={ringsmy} alt="" />
                            </div>
                            <div className="profile-2">
                                <img objectFit="contain" className="avatar" src={imgB3} alt="" />
                                <img className="rings" src={ringscy} alt="" />
                            </div>
                        </div>
                        <div className="info board-teaser">
                            <div ref={(element) => titleSupers.current[1] = element} data-scroll data-scroll-speed="3" className="title--super text--outline">Leading</div>
                            <h1 ref={(element) => titles.current[1] = element} data-scroll data-scroll-speed="2">Together</h1>
                            <div className="button-wrap">
                                <TransitionLink
                                    className="button"
                                    to="/board-ceo-letters"
                                    exit={{
                                        trigger: ({ exit, node }) => exitAnimation(exit, node, 1, [1,2,3]),
                                        length: .6,
                                    }}
                                    entry={{
                                        delay: .6,
                                    }}
                                >
                                    Read Board & CEO Letters
                                </TransitionLink>
                            </div>
                        </div>
                    </div>
                    <div 
                        ref={(element) => circles.current[2] = element}
                        className="circle--yellow p-2"
                        data-scroll
                        data-scroll-speed="3"
                        data-scroll-direction="horizontal"
                    ></div>
                    <div
                        ref={(element) => circles.current[3] = element}
                        className="circle--green p-2" 
                        data-scroll
                        data-scroll-speed="2" 
                        data-scroll-direction="vertical"
                    ></div>
                </div>
                <div className="teaser" ref={(element) => teasers.current[2] = element}>
                    <div className="wrap">
                        <div className="profile" data-scroll-call="scrollCall" data-scroll-id="2" data-scroll data-scroll-speed="0">
                            <img objectFit="contain" className="avatar" src={imgB2} alt="" />
                            <img className="rings" src={ringsby} alt="" />
                        </div>
                        <div className="info officers-teaser">
                            <div ref={(element) => titleSupers.current[2] = element} data-scroll data-scroll-speed="3" className="title--super text--outline">MAKING AN
                        </div>
                            <h1 ref={(element) => titles.current[2] = element} data-scroll data-scroll-speed="2">IMPACT</h1>
                            <div className="button-wrap">
                                <TransitionLink
                                    className="button"
                                    to="/officers"
                                    exit={{
                                        trigger: ({ exit, node }) => exitAnimation(exit, node, 2, [3,4,5]),
                                        length: .5,
                                    }}
                                    entry={{
                                        delay: 0.5,
                                    }}
                                >
                                    Meet Our Officers
                                </TransitionLink>
                            </div>
                        </div>
                    </div>
                    <div
                        ref={(element) => circles.current[4] = element} 
                        className="circle-2 p-3"
                        data-scroll
                        data-scroll-speed="2"
                        data-scroll-direction="vertical"
                    ></div>
                    <div
                        ref={(element) => circles.current[5] = element}
                        className="circle-1 p-3" 
                        data-scroll
                        data-scroll-speed="3" 
                        data-scroll-direction="horizontal"
                    ></div>
                </div>
                <div className="teaser" ref={(element) => teasers.current[3] = element}>
                    <div className="wrap">
                        <div className="profile" data-scroll-call="scrollCall" data-scroll-id="3" data-scroll data-scroll-speed="0">
                            <img objectFit="contain" className="avatar" src={imgC} alt="" />
                            <img className="rings" src={ringsmy} alt="" />
                        </div>
                        <div className="info operations-teaser">
                            <div ref={(element) => titleSupers.current[3] = element} data-scroll data-scroll-speed="3" className="title--super text--outline">MEETING CRITICAL
                        </div>
                            <h1 ref={(element) => titles.current[3] = element} data-scroll data-scroll-speed="2">NEEDS</h1>
                            <div className="button-wrap">
                                <TransitionLink
                                    className="button"
                                    to="/operations"
                                    exit={{
                                        trigger: ({ exit, node }) => exitAnimation(exit, node, 3, [4,5,6]),
                                        length: .5,
                                    }}
                                    entry={{
                                        delay: 0.5,
                                    }}
                                >
                                    Read About Our Operations 
                                </TransitionLink>
                            </div>
                        </div>
                    </div>
                    {/*<div
                        ref={(element) => circles.current[6] = element} 
                        className="circle--blue p-4"
                        data-scroll
                        data-scroll-speed="2"
                        data-scroll-direction="vertical"
                    ></div>*/}
                    <div
                        ref={(element) => circles.current[6] = element}
                        className="circle--green p-4" 
                        data-scroll
                        data-scroll-speed="3" 
                        data-scroll-direction="horizontal"
                    ></div>
                </div>
                <div className="teaser" ref={(element) => teasers.current[4] = element}>
                    <div className="wrap">
                        <div className="profile" data-scroll-call="scrollCall" data-scroll-id="4" data-scroll data-scroll-speed="0">
                            <img objectFit="contain" className="avatar" src={imgD} alt="" />
                            <img className="rings" src={ringsby} alt="" />
                        </div>
                        <div className="info markets-teaser">
                            <div ref={(element) => titleSupers.current[4] = element} data-scroll data-scroll-speed="3" className="title--super text--outline">DRIVING
                        </div>
                            <h1 ref={(element) => titles.current[4] = element} data-scroll data-scroll-speed="2">EFFICIENCY</h1>
                            <div className="button-wrap">
                                <TransitionLink
                                    className="button"
                                    to="/markets"
                                    exit={{
                                        trigger: ({ exit, node }) => exitAnimation(exit, node, 4, [12,13,14]),
                                        length: .5,
                                    }}
                                    entry={{
                                        delay: 0.5,
                                    }}
                                >
                                    Read About Markets
                                </TransitionLink>
                            </div>
                        </div>
                    </div>
                    <div
                        ref={(element) => circles.current[14] = element} 
                        className="circle--blue p-9"
                        data-scroll
                        data-scroll-speed="2"
                        data-scroll-direction="vertical"
                    ></div>
                </div>
                <div className="teaser" ref={(element) => teasers.current[5] = element}>
                    <div className="wrap">
                        <div className="profile" data-scroll-call="scrollCall" data-scroll-id="5" data-scroll data-scroll-speed="0">
                            <img objectFit="contain" className="avatar" src={imgE} alt="" />
                            <img className="rings" src={ringsbm} alt="" />
                        </div>
                        <div className="info reliability-teaser">
                            <div ref={(element) => titleSupers.current[5] = element} data-scroll data-scroll-speed="3" className="title--super text--outline">TRANSFORMING
                        </div>
                            <h1 ref={(element) => titles.current[5] = element} data-scroll data-scroll-speed="2">THE GRID</h1>
                            <div className="button-wrap">
                                <TransitionLink
                                    className="button"
                                    to="/reliability"
                                    exit={{
                                        trigger: ({ exit, node }) => exitAnimation(exit, node, 5, [6,7,8]),
                                        length: .5,
                                    }}
                                    entry={{
                                        delay: 0.5,
                                    }}
                                >
                                    Read About Reliability & Resilience
                                </TransitionLink>
                            </div>
                        </div>
                    </div>
                    <div
                        ref={(element) => circles.current[7] = element} 
                        className="circle--pink p-5"
                        data-scroll
                        data-scroll-speed="2"
                        data-scroll-direction="horizontal"
                    ></div>
                    <div
                        ref={(element) => circles.current[8] = element}
                        className="circle--yellow p-5" 
                        data-scroll
                        data-scroll-speed="-3" 
                        data-scroll-direction="vertical"
                    ></div>
                </div>
                <div className="teaser" ref={(element) => teasers.current[6] = element}>
                    <div className="wrap">
                        <div className="profile" data-scroll-call="scrollCall" data-scroll-id="6" data-scroll data-scroll-speed="0">
                            <img objectFit="contain" className="avatar" src={imgF} alt="" />
                            <img className="rings" src={ringsby} alt="" />
                        </div>
                        <div className="info planning-teaser">
                            <div ref={(element) => titleSupers.current[6] = element} data-scroll data-scroll-speed="3" className="title--super text--outline">ENVISIONING THE
                        </div>
                            <h1 ref={(element) => titles.current[6] = element} data-scroll data-scroll-speed="2">FUTURE</h1>
                            <div className="button-wrap">
                                <TransitionLink
                                    className="button"
                                    to="/planning"
                                    exit={{
                                        trigger: ({ exit, node }) => exitAnimation(exit, node, 6, [9,10,11]),
                                        length: .5,
                                    }}
                                    entry={{
                                        delay: 0.5,
                                    }}
                                >
                                    Read About Planning 
                                </TransitionLink>
                            </div>
                        </div>
                    </div>
                    <div
                        ref={(element) => circles.current[10] = element} 
                        className="circle--green p-7"
                        data-scroll
                        data-scroll-speed="1"
                        data-scroll-direction="horizontal"
                    ></div>
                    <div
                        ref={(element) => circles.current[11] = element} 
                        className="circle--yellow p-7"
                        data-scroll
                        data-scroll-speed="2"
                        data-scroll-direction="vertical"
                    ></div>
                </div>
                <div className="teaser" ref={(element) => teasers.current[7] = element}>
                    <div className="wrap">
                        <div className="profile" data-scroll-call="scrollCall" data-scroll-id="7" data-scroll data-scroll-speed="0">
                            <img objectFit="contain" className="avatar" src={imgG} alt="" />
                            <img className="rings" src={ringsby} alt="" />
                        </div>
                        <div className="info risk-management-teaser">
                            <div ref={(element) => titleSupers.current[7] = element} data-scroll data-scroll-speed="3" className="title--super text--outline">EVOLVING
                        </div>
                            <h1 ref={(element) => titles.current[7] = element} data-scroll data-scroll-speed="2">PROGRESS</h1>
                            <div className="button-wrap">
                                <TransitionLink
                                    className="button"
                                    to="/risk-management"
                                    exit={{
                                        trigger: ({ exit, node }) => exitAnimation(exit, node, 7, [7,8,9]),
                                        length: .5,
                                    }}
                                    entry={{
                                        delay: 0.5,
                                    }}
                                >
                                    Read About Risk Management 
                                </TransitionLink>
                            </div>
                        </div>
                    </div>
                    <div
                        ref={(element) => circles.current[9] = element} 
                        className="circle--blue p-6"
                        data-scroll
                        data-scroll-speed="2"
                        data-scroll-direction="vertical"
                    ></div>
                </div>

                <div className="teaser" ref={(element) => teasers.current[8] = element}>
                    <div className="wrap">
                        <div className="profile" data-scroll-call="scrollCall" data-scroll-id="8" data-scroll data-scroll-speed="0">
                            <img objectFit="contain" className="avatar" src={imgH} alt="" />
                            <img className="rings"  src={ringscy} alt="" />
                        </div>
                        <div className="info innovation-teaser">
                            <div ref={(element) => titleSupers.current[8] = element} data-scroll data-scroll-speed="3" className="title--super text--outline">ADVANCING OUR
                        </div>
                            <h1 ref={(element) => titles.current[8] = element} data-scroll data-scroll-speed="2">EFFORTS</h1>
                            <div className="button-wrap">
                                <TransitionLink
                                    className="button"
                                    to="/innovation"
                                    exit={{
                                        trigger: ({ exit, node }) => exitAnimation(exit, node, 8, [11,12,13]),
                                        length: .5,
                                    }}
                                    entry={{
                                        delay: 0.5,
                                    }}
                                >
                                    Read About Innovation
                                </TransitionLink>
                            </div>
                        </div>
                    </div>
                    <div
                        ref={(element) => circles.current[12] = element} 
                        className="circle--pink p-8"
                        data-scroll
                        data-scroll-speed="-1"
                        data-scroll-direction="vertical"
                    ></div>
                    <div
                        ref={(element) => circles.current[13] = element} 
                        className="circle--blue p-8"
                        data-scroll
                        data-scroll-speed="3"
                        data-scroll-direction="horizontal"
                    ></div>
                </div>
       
                <div className="teaser" ref={(element) => teasers.current[9] = element}>
                    <div className="wrap">
                        <div className="profile" data-scroll-call="scrollCall" data-scroll-id="9" data-scroll data-scroll-speed="0">
                            <img objectFit="contain" className="avatar" src={imgI} alt="" />
                            <img className="rings"  src={ringsbm} alt="" />
                        </div>
                        <div className="info caring-teaser">
                            <div ref={(element) => titleSupers.current[9] = element} data-scroll data-scroll-speed="3" className="title--super text--outline">SUPPORTING OUR
                        </div>
                            <h1 ref={(element) => titles.current[9] = element} data-scroll data-scroll-speed="2">WORKFORCE</h1>
                            <div className="button-wrap">
                                <TransitionLink
                                    className="button"
                                    to="/culture-of-caring"
                                    exit={{
                                        trigger: ({ exit, node }) => exitAnimation(exit, node, 9, [7,8,9]),
                                        length: .5,
                                    }}
                                    entry={{
                                        delay: 0.5,
                                    }}
                                >
                                    Read About Our Culture of Caring
                                </TransitionLink>
                            </div>
                        </div>
                    </div>
                    <div
                        ref={(element) => circles.current[15] = element} 
                        className="circle--yellow p-10"
                        data-scroll
                        data-scroll-speed="3"
                        data-scroll-direction="vertical"
                    ></div>
                    <div
                        ref={(element) => circles.current[16] = element} 
                        className="circle--pink p-10"
                        data-scroll
                        data-scroll-speed="-1"
                        data-scroll-direction="vertical"
                    ></div>
                </div>
            </div>
        </div>
        </>
    )
}